import { render } from "./ProfileAttentionTrends.vue?vue&type=template&id=59046d0c&scoped=true"
import script from "./ProfileAttentionTrends.vue?vue&type=script&lang=js"
export * from "./ProfileAttentionTrends.vue?vue&type=script&lang=js"

import "./ProfileAttentionTrends.vue?vue&type=style&index=0&id=59046d0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59046d0c"]])

export default __exports__